import Test from "./Components/Test/Test";
import { Switch, Route, useLocation } from "react-router-dom";
import AboutUs from "./Components/AboutUs/AboutUs";
import ContactUs from "./Components/ContactUs/ContactUs";
import ContactUsBL from "./Components/ContactUs/ContactUs-BL";
import RatesCPH from "./Components/Rates/RatesCPH";
import RatesBLL from "./Components/Rates/RatesBLL";
import TrackTrace from "./Components/TrackTrace/TrackTrace";
import TrackResults from "./Components/TrackTrace/TrackResults";
import NotFound from "./Components/NotFound/NotFound";
import React, {useState,useEffect} from "react";
import NavigationBarClean from "./Components/TopComponents/NavigationBarClean";
import AnalyticsDashboard from "./Components/Analytics/AnalyticsDashboard";
import AccessManagement from "./Components/Admin/AccessManagement";
import usePageVisitTracker from "./hooks/usePageVisitTracker";
import ProtectedRoute from "./Components/Auth/ProtectedRoute";
import { useIsAuthenticated } from "@azure/msal-react";


const App = () => {
  // Track page visits automatically for all routes
  usePageVisitTracker();
  const location = useLocation();
  const isAuthenticated = useIsAuthenticated();
  
  // Hide navigation bar on protected routes when not authenticated (login page)
  const protectedRoutes = ['/analytics', '/access-management'];
  const shouldShowNav = !(protectedRoutes.includes(location.pathname) && !isAuthenticated);

  useEffect(() => {
    // Hide HTML loader as soon as React component loads
    const htmlLoader = document.getElementById('initial-loader');
    if (htmlLoader) {
      htmlLoader.classList.add('fade-out');
      setTimeout(() => {
        htmlLoader.style.display = 'none';
      }, 500);
    }
  }, []);


  return (
    <>
      {shouldShowNav && <NavigationBarClean />}
      <div className="main-wrapper">
        <Switch>
          <Route path="/" exact component={Test} />
          <Route path="/about-us" component={AboutUs} />
          <Route path="/contact-us-cp" component={ContactUs} />
          <Route path="/contact-us-bl" component={ContactUsBL} />
          <Route path="/ratescph" component={RatesCPH}/>
          <Route path="/ratesbll" component={RatesBLL}/>
          {/* <Route path="/track-trace" component={TrackTrace} />
          <Route path="/track-results" component={TrackResults} /> */}
          <Route path="/analytics">
            <ProtectedRoute>
              <AnalyticsDashboard />
            </ProtectedRoute>
          </Route>
          <Route path="/access-management">
            <ProtectedRoute>
              <AccessManagement />
            </ProtectedRoute>
          </Route>
          {/* Catch-all route for 404 - MUST be last */}
          <Route component={NotFound} />
        </Switch>
      </div> 
    </>
  );
};

export default App;
